<template>
  <div class="AllView r-cover overflow-hidden">
    <!-- Header Transition -->
    <transition name="fade">
      <div
        :key="wrapperKey"
        :class="wrapperClasses"
      >
        <Header
          v-if="hasHeader"
        />
        <main class="r-cover overflow-hidden">
          <!-- Route Transition -->
          <transition name="fade">
            <router-view />
          </transition>
        </main>
      </div>
    </transition>

    <!-- Live events -->
    <LiveEvents />

    <!-- Menu -->
    <Menu />

    <!-- Unibuddy -->
    <Unibuddy />

    <!-- TheAccessPlatform -->
    <TheAccessPlatform />

    <!-- Modal content -->
    <ContentModal />
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import LiveEvents from '@/components/LiveEvents.vue'
import Menu from '@/components/Menu.vue'
import Unibuddy from '@/components/Unibuddy.vue'
import TheAccessPlatform from '@/components/TheAccessPlatform.vue'
import ContentModal from '@/components/ContentModal.vue'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'All',

  components: {
    Header,
    LiveEvents,
    Menu,
    Unibuddy,
    TheAccessPlatform,
    ContentModal
  },

  computed: {
    // Data
    ...mapState([
      'settings',
    ]),
    ...mapGetters([
      'routeName',
    ]),
    hasHeader() {
      const noHeaderRoute = ['home'].includes(this.routeName)
      return !noHeaderRoute
    },
    wrapperClasses() {
      const { hasHeader } = this
        // :key="`has-header-${hasHeader ? 'true' : 'false'}`"
      return [
        'absolute inset-0',
        'overflow-hidden',
        'px-3 md:px-5',
        hasHeader ? 'pt-15 md:pt-20' : 'pt-3 md:pt-5',
        'pb-3 md:pb-5',
      ]
    },
    wrapperKey() {
      const { hasHeader } = this
      return `has-header-${hasHeader ? 'true' : 'false'}`
    },
  }
}
</script>
